module.exports = __webpack_public_path__ + "img/DCN.4c92a1a9.svg";